// eslint-disable-next-line
import { appInfo } from "@/common/data/appinfo";
// eslint-disable-next-line
import { useAuthStore } from "@/store/auth";
export default [
  {
    path: "/f2TEBgyrD",
    name: "TokenLogin",
    component: () => import("@/views/auth/tokenLogin.vue"),
    meta: {
      title: "Login with Code",
    },
  },
  {
    path: "/f2o3gyrD",
    name: "verifySchool",
    component: () => import("@/views/auth/register.vue"),
    meta: {
      title: "Verify School",
    },
  },
  {
    path: "/v17Kc03bfc",
    name: "newApplication",
    component: () => import("@/views/auth/register2.vue"),
    meta: {
      title: "New application",
    },
  },
  {
    path: "/kxwnd4154f2869b314500467ea0dS7",
    name: "reset-password",
    meta: {
      title: "Reset Password",
    },
    component: () => import("@/views/auth/reset-password.vue"),
  },
  {
    path: "/kxwndbab201e91f20673a03300b6QrS7",
    name: "change-password",
    component: () => import("@/views/auth/update-password.vue"),
    meta: {
      title: "Change Password",
      authRequired: true,
    },
  },
  {
    path: "/eccb9304e7057678a40c94a3",
    name: "forgotten-password",
    authRequired: false,
    component: () => import("@/views/auth/forgotten-password.vue"),
    meta: {
      title: "Forgot Password",
      authRequired: false,
    },
  },
  {
    path: "/qPnXK09a371cc48e6efe5d17b5dafANObF",
    name: "checkConsentStatus",
    meta: {
      title: "Check consent status",
      authRequired: false,
    },
    component: () => import("@/views/auth/checkConsent.vue"),
  },
  {
    path: "/qPnXKANObF",
    name: "checkApplicationStatus",
    meta: {
      title: "Check application status",
      authRequired: false,
    },
    component: () => import("@/views/auth/checkapplication.vue"),
  },
];
